import { render, staticRenderFns } from "./PesquisaAtoInfralegal.vue?vue&type=template&id=113dfc42&scoped=true"
import script from "./PesquisaAtoInfralegal.vue?vue&type=script&lang=js"
export * from "./PesquisaAtoInfralegal.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAtoInfralegal.vue?vue&type=style&index=0&id=113dfc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113dfc42",
  null
  
)

export default component.exports